export default "__VITE_ASSET__CfRJOY9U__"